export default __webpack_public_path__ + "static/media/BriteWinLogo.e7f56143.svg";